import { sanitizeHTML } from "src/app/support/sanitize";

export function hash(value: string): number {
  let hash = 0,
    i,
    chr;
  if (value.length === 0) return hash;
  for (i = 0; i < value.length; i++) {
    chr = value.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
}

export function replaceHTMLBRWithNewLine(html: string): string {
  return html.replaceAll("<br/>", "\n").replaceAll("<BR/>", "\n");
}

export function stripHTMLTags(html: string): string {
  return !html || html === "undefined" ? "" : sanitizeHTML(html);
}

export function trimStarEndingNewLines(value: string): string {
  return value.replace(/^\s+|\s+$/g, "");
}

export function stringRemoveNonAsciiChar(value: string): string {
  return value.replace(/[^\x00-\x7F]/g, "");
}

export function stringTruncateMiddle(
  value: string,
  leftChars: number,
  rightChars: number
): string {
  if (value.length < leftChars + rightChars) {
    return value;
  }

  return `${value.slice(0, leftChars)}...${value.slice(
    value.length - rightChars,
    value.length
  )}`;
}
